import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "help", "isTooltip"];
import React from 'react';
import { Tag, Tooltip } from '@beef/ui-kit';
export var DeviceTag = function DeviceTag(_ref) {
  var children = _ref.children,
    help = _ref.help,
    isTooltip = _ref.isTooltip,
    rest = _objectWithoutProperties(_ref, _excluded);
  return isTooltip ? /*#__PURE__*/React.createElement(Tooltip, {
    message: help
  }, /*#__PURE__*/React.createElement(Tag, rest, children)) : /*#__PURE__*/React.createElement(Tag, rest, children);
};